/**
 * Textos de Compres (`en`): tall «filtres» de les millores de Compres (OBR-190 / OBR-181 / OBR-117). Tall propi: no es toca `en.ts`.
 * Filtres de les llistes d'Albarans, Excepcions i Devolucions (OBR-181). Les tres llengües han de tenir les mateixes claus (i18n.test.ts); cap text literal a les vistes.
 * El proveïdor i «Treu els filtres» reutilitzen les claus de Comandes (`backoffice.purchaseOrders`).
 */

export const filtresEn = {
  'backoffice.purchaseFilters': {
    receptionsSearch: 'Search by delivery note, order, supplier or invoice',
    receptionsStatusConfirmed: 'Confirmed',
    receptionsStatusDraft: 'Draft',
    receptionDateFrom: 'Received from',
    receptionDateTo: 'Received to',
    receptionsEmptyFiltered: 'No delivery note matches these filters. Try widening them, or clear them.',
    exceptionsSearch: 'Search by delivery note, order, supplier or article',
    exceptionsEmptyFiltered: 'No exception matches these filters. Try widening them, or clear them.',
    returnsSearch: 'Search by return, delivery note, order, supplier, article or lot',
    returnsDateFrom: 'Created from',
    returnsDateTo: 'Created to',
    returnsEmptyFiltered: 'No return matches these filters. Try widening them, or clear them.',
  },
} as const;
